import type { GetCurrentActivitiesEditorsSubscription } from '../../../lesson-builder.graphql.generated';
import {
  WS_EVENT_ACTION_ONLINE,
  WS_EVENT_ACTION_DISCONNECT,
} from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

type Editor = Pluck<
  GetCurrentActivitiesEditorsSubscription,
  'getCurrentActivitiesEditors'
>;

/**
 * Handles the processing of activity editors subscription data
 * @param editors - Array of editors from the subscription
 * @param getCurrentEditors - Function to get current editors state
 * @param setEditors - Function to set editors state
 */
export function processActivityEditorsUpdate(
  editors: Editor[] | null | undefined,
  getCurrentEditors: () => Editor[],
  setEditors: (editors: Editor[]) => void
) {
  if (!editors || editors.length === 0) {
    setEditors([]);
    return;
  }

  // Handle the subscription data based on action
  editors.forEach(editor => {
    if (editor.action === WS_EVENT_ACTION_ONLINE) {
      // Add or update editor
      const current = getCurrentEditors();
      const existingIndex = current.findIndex(
        e => e.editorId === editor.editorId
      );

      if (existingIndex >= 0) {
        // Update existing editor
        const updated = [...current];
        updated[existingIndex] = editor;
        setEditors(updated);
      } else {
        // Add new editor
        setEditors([...current, editor]);
      }
    } else if (editor.action === WS_EVENT_ACTION_DISCONNECT) {
      // Remove editor
      const current = getCurrentEditors();
      setEditors(current.filter(e => e.editorId !== editor.editorId));
    }
  });
}
